import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import { usePayerTripRequiredField } from '../usePayerTripRequiredField';
import { pricingNameRoot } from './pricingNameRoot';
import { useAppSelector } from 'src/app/store/hooks';
import type { PayerOrganizationRead } from 'src/common/external/bambi-api/bambiApi';
import { usePayersPassengersRetrieveQuery } from 'src/common/external/bambi-api/bambiApi';
import { FormField } from 'src/common/FormField';
import { FormFieldController } from 'src/common/FormField/FormFieldController';

export function BrokerPayerFields({
  selectedPayer,
}: {
  selectedPayer: PayerOrganizationRead | null;
}) {
  const { setValue } = useFormContext();

  const selectedPassenger = useAppSelector(
    (state) => state.addATrip.selectedPassenger
  );

  const { data: payerPassenger } = usePayersPassengersRetrieveQuery(
    {
      passengerId: selectedPassenger?.id || '',
      payerOrganizationId: selectedPayer?.id || '',
    },
    {
      skip:
        !selectedPassenger?.id ||
        !selectedPayer?.id ||
        selectedPayer.payer_type !== 'broker',
    }
  );

  const isPayerPassengerExternalIdRequired = usePayerTripRequiredField(
    'payer_passenger_external_id',
    selectedPayer
  );

  useEffect(() => {
    if (payerPassenger) {
      setValue(
        `${pricingNameRoot}.payer_passenger_external_id`,
        payerPassenger.external_id
      );
    }
  }, [payerPassenger, setValue]);

  return (
    <>
      <div className="grow" data-testid="broker-payer-fields">
        <FormFieldController
          name={`${pricingNameRoot}.payer_passenger_external_id`}
          rules={{
            required: isPayerPassengerExternalIdRequired
              ? 'Member ID is required'
              : undefined,
          }}
        >
          {({ field, fieldState }) => {
            return (
              <FormField
                label="Member ID"
                error={fieldState.error?.message?.toString()}
                type="text"
                inputProps={{
                  id: `${pricingNameRoot}.payer_passenger_external_id`,
                  ...field,
                }}
              />
            );
          }}
        </FormFieldController>
      </div>
    </>
  );
}
